import axios from 'axios'
import config from 'config'

export default async function getLeadsCount() {
    const { data } = await axios.get(
        // eslint-disable-next-line max-len
        `${config.API_BASE_URL}/api/v3/applications/leads-count/new-leads-count/`,
        {
            withCredentials: true,
        },
    )

    return data
}
